let app = {

   init() {
      if (document.querySelector('.palmares')) {
         let elements = document.querySelectorAll('.palmares p')
         elements.forEach((element) => {
            if (element.querySelector('strong,b') && element.previousElementSibling) {
               element.previousElementSibling.style.marginBottom = '3em'
            }
            var position = element.innerHTML.indexOf(":");
            if (position !== -1) {
               console.log(element.innerHTML)
               element.innerHTML = [element.innerHTML.slice(0, position+1), '<br><br>', element.innerHTML.slice(position+1)].join('');
            }
         })
      }
   }
}

setTimeout(() => {
   app.init()
}, 0)
